const type = 'RESET_CARD';

const resetCard = () => ({
  type,
});

export { type };
export default resetCard;
